import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient instance для React Query
 * 
 * Настройки по умолчанию:
 * - refetchInterval: false - отключение автоматического обновления
 * - refetchOnWindowFocus: false - отключение обновления при фокусе окна
 * - staleTime: Infinity - данные не устаревают автоматически
 * - retry: false - отключение повторных попыток при ошибках
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
